import React, { useEffect } from 'react';
import { Row, Col, Avatar, Card, Button, Spin, Modal } from 'antd';
// import format from 'date-fns/format';
import { Link, useNavigate } from 'react-router-dom';
import '../../css/custom.css';
import Profile from '../../Images/Prof.png';
import Tag from '../../Images/Tag.png';
import noProfile from '../../Images/noProfile.png';
import { useAuth } from '../../Context';
import { BodyTextHeading, BodyTextKey, BodyTextValue, ButtonText } from '../CommonText';

import english from '../../Translations/English.json';
import hindi from '../../Translations/Hindi.json';
import malayalam from '../../Translations/Malayalam.json';
import dayjs from 'dayjs';
import { cancelRedirect } from './Actions';
import { useDispatch } from 'react-redux';

const MyProfileFront = () => {

    const {profileGet, patientDeatils} = useAuth();

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const profiles = patientDeatils && patientDeatils ? patientDeatils[0] : null;
    const requesting = false;

    useEffect(() => {
        profileGet();
        dispatch(cancelRedirect());
    }, []);

    const langid = localStorage.getItem('INTL') ? (localStorage.getItem('INTL')) : 'en';
    const langdata = langid && langid == 'en' ? english : langid == 'ma' ? malayalam : langid == 'hin' ? hindi : english;
    
    const patientId = sessionStorage.getItem('PATIENT_ID');    

    useEffect(() => {
        if (!patientId) {
            Modal.warning({
                title: 'Complete your profile',
                content: 'Please complete your profile details here...',
            });
            navigate('/addprofile');
        }
    },[]);    

    let profBody;
    if (profiles !== null) {
        profBody = (
            <div key={profiles.id}>
                <Row type="flex" justify="center">
                    <Col xs={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }} xl={{ span: 24 }} xxl={{ span: 24 }}>
                        {/* Upper Header contains profile photo, name, edit button */}
                        {window.innerWidth < 766 ? (
                            <Row style={{ textAlign: 'center' }}>
                                <Col xs={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }} xl={{ span: 24 }} xxl={{ span: 24 }} style={{ background: '#1164A6' }}>
                                    <Row>
                                        <Col
                                            xs={{ span: 24, offset: 0 }}
                                            style={{
                                                marginTop: '10px',
                                                textAlign: 'center',
                                                paddingTop: '10px',
                                                paddingBottom: '10px',
                                            }}
                                        >
                                            <Avatar
                                                style={{ width: '90px', height: '90px' }}
                                                src={profiles.profilephotourl ? profiles.profilephotourl : noProfile}
                                            />
                                        </Col>
                                        <Col
                                            xs={{ span: 24, offset: 0 }}
                                            md={{ span: 10, offset: 2 }}
                                            lg={{ span: 11, offset: 1 }}
                                            xl={{ span: 20 }}
                                            style={{
                                            // marginTop: '10px',
                                                fontWeight: '100',
                                                fontSize: '22px',
                                                color: '#FFFFFF',
                                                fontFamily: 'Roboto',
                                            }}
                                        >
                                            <BodyTextHeading text = {`${profiles.initials} ${profiles.firstName} ${profiles.lastName}`} color='#ffffff'/>
                                        </Col>
                                        <Col xs={{ span: 22 }} style={{ marginTop: '10px', textAlign: 'right', marginBottom: '10px' }}>
                                            <Link to="/profile">
                                                <Button type="primary" style={{ backgroundColor: '#1164A6', borderColor: '#ffffff', borderRadius: '10px' }}>
                                                    <ButtonText text = {`${langdata.Edit ? langdata.Edit : 'Edit' }`} />
                                                </Button>
                                            </Link>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        ) : (
                            <Row>
                                <Col xs={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }} xl={{ span: 24 }} xxl={{ span: 24 }} style={{ height: '100px', background: '#1164A6' }}>
                                    <Row>
                                        <Col
                                            xs={{ span: 4 }}
                                            sm={{ span: 3}}
                                            md={{ span: 3 }}
                                            lg={{ span: 2 }}
                                            xl={{ span: 2 }}
                                            xxl={{ span: 2 }}
                                            style={{
                                                // marginTop: '24px',
                                                marginLeft: '1%',
                                                paddingTop: '5px',
                                                // paddingBottom: '10px',
                                                display : 'flex',
                                                justifyContent : 'center'
                                            }}
                                        >
                                            <Avatar
                                                style={{ width: '90px', height: '90px' }}
                                                src={profiles.profilephotourl ? profiles.profilephotourl : noProfile}
                                            />
                                        </Col>
                                        <Col
                                            xs={{ span: 10, offset: 1 }}
                                            md={{ span: 10, offset: 1 }}
                                            lg={{ span: 11, offset: 1 }}
                                            xl={{ span: 13, offset: 0 }}
                                            xxl={{ span: 12, offset: 0 }}
                                            style={{
                                                marginTop: '35px',
                                                // fontWeight: '100',
                                                fontSize: '22px',
                                                color: '#FFFFFF',
                                                // fontFamily: 'Roboto',
                                            }}
                                        >
                                            <BodyTextHeading text = {`${profiles.initials} ${profiles.firstName} ${profiles.lastName}`} color='#ffffff' /> 
                                        </Col>
                                        <Col xs={{ span: 5 }} sm={{span : 9}} md={{ span: 9 }} lg={{ span: 9 }} xl={{ span: 8 }} xxl={{ span: 9 }} style={{ marginTop: '35px', textAlign: 'right' }}>
                                            {/* <Link to="/profile"> */}
                                            <Button 
                                                type="primary" 
                                                onClick={() => {navigate('/profile');}}
                                                style={{ backgroundColor: '#1164A6', borderColor: '#ffffff', borderRadius: '10px' }}>
                                                <ButtonText text = {`${langdata.Edit ? langdata.Edit : 'Edit' }`} />
                                            </Button>
                                            {/* </Link> */}
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        )}

                        {/* Body Personal info */}
                        <Row>
                            <Col
                                xs={{ span: 24 }}
                                md={{ span: 22 }}
                                lg={{ span: 22 }}
                                xl={{ span: 24 }}
                                xxl={{ span: 24 }}
                            >
                                <Row>
                                    <Col
                                        xs={{ span: 22, offset: 1 }}
                                        md={{ span: 22, offset: 1 }}
                                        lg={{ span: 10, offset: 1 }}
                                        xl={{ span: 10, offset: 1 }}
                                        xxl={{ span: 10, offset: 1 }}
                                    >
                                        <Card
                                            style={{
                                                marginBottom: '10px',
                                                width: '100%',
                                                marginTop: '20px',
                                                boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.18)',
                                                borderRadius: '8px',
                                                paddingBottom: '20px',
                                            }}
                                        >
                                            {/* <Row> */}
                                            <Col>
                                                <div style={{ float: 'left' }}>
                                                    <Avatar
                                                        shape="square"
                                                        src={Profile}
                                                        style={{ width: '31px', height: '33px' }}
                                                    />
                                                </div>
                                                <div style={{ fontSize: '21px', marginLeft: '6%', color: '#000000' }}>
                                                    <BodyTextHeading text={`${langdata.PersonalInfo ? langdata.PersonalInfo : 'Personal Info' }`} />
                                                </div>
                                            </Col>
                                            {/* </Row> */}
                                            <Row style={{ marginTop: '12px' }}>
                                                <Col>
                                                    <div
                                                        style={{
                                                            color: '#828282',
                                                            fontSize: '16px',
                                                            fontFamily: 'Roboto',
                                                            paddingTop: '14px',
                                                        }}
                                                    >
                                                        <BodyTextKey text={`${langdata.Name ? langdata.Name : 'Name' }`}/>&nbsp;:&nbsp;
                                                        <BodyTextValue text={`${profiles.initials} ${profiles.firstName} ${profiles.lastName}`} />
                                                    </div>
                                                    <div
                                                        style={{
                                                            color: '#828282',
                                                            fontSize: '16px',
                                                            fontFamily: 'Roboto',
                                                            paddingTop: '14px',
                                                        }}
                                                    >
                                                        <BodyTextKey text={`${langdata.Gender ? langdata.Gender : 'Gender' }`}/>&nbsp;:&nbsp;
                                                        <BodyTextValue text={profiles.gender} />
                                                    </div>
                                                    <div
                                                        style={{
                                                            color: '#828282',
                                                            fontSize: '16px',
                                                            fontFamily: 'Roboto',
                                                            paddingTop: '14px',
                                                        }}
                                                    >
                                                        <BodyTextKey text={`${langdata.BloodGroup ? langdata.BloodGroup : 'Blood Group' }`}/>&nbsp;:&nbsp;
                                                        <BodyTextValue text={profiles.bloodGroup ? profiles.bloodGroup : 'Not Specified' } />
                                                    </div>
                                                    <div
                                                        style={{
                                                            color: '#828282',
                                                            fontSize: '16px',
                                                            fontFamily: 'Roboto',
                                                            paddingTop: '14px',
                                                        }}
                                                    >
                                                        <BodyTextKey text={`${langdata.DateofBirth ? langdata.DateofBirth : 'Date of Birth' }`}/>&nbsp;:&nbsp;
                                                        <BodyTextValue text={profiles.dob ? dayjs(profiles.dob).format('DD-MM-YYYY') : null} />
                                                    </div>
                                                    <div
                                                        style={{
                                                            color: '#828282',
                                                            fontSize: '16px',
                                                            fontFamily: 'Roboto',
                                                            paddingTop: '14px',
                                                        }}
                                                    >
                                                        <BodyTextKey text={`${langdata.Nationality ? langdata.Nationality : 'Nationality' }`}/>&nbsp;:&nbsp;
                                                        <BodyTextValue text={profiles.nationality ? profiles.nationality : 'Not Specified' } />
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Card>
                                    </Col>

                                    <Col
                                        xs={{ span: 22, offset: 1 }}
                                        md={{ span: 22, offset: 1 }}
                                        lg={{ span: 11, offset: 1 }}
                                        xl={{ span: 11, offset: 1 }}
                                        xxl={{ span: 11, offset: 1 }}
                                    >
                                        <Card
                                            style={{
                                                width: '100%',
                                                marginTop: '20px',
                                                boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.18)',
                                                borderRadius: '8px',
                                                marginBottom: '10px',
                                                paddingBottom: '20px',
                                            }}
                                        >
                                            {/* <Row> */}
                                            <Col>
                                                <div style={{ float: 'left' }}>
                                                    <Avatar
                                                        shape="square"
                                                        src={Tag}
                                                        style={{ width: '20px', height: '30px', marginTop: '10%' }}
                                                    />
                                                </div>
                                                <div style={{ fontSize: '21px', marginLeft: '4%', color: '#000000' }}>
                                                    <BodyTextHeading text={`${langdata.Contact ? langdata.Contact : 'Contact'}`} />
                                                </div>
                                            </Col>
                                            {/* </Row> */}
                                            <Row style={{ marginTop: '24px' }}>
                                                <Col>
                                                    <div style={{ color: '#828282', fontSize: '16px', fontFamily: 'Roboto' }}>
                                                        <BodyTextKey text={`${langdata.Email ? langdata.Email : 'Email' }`}/>&nbsp;:&nbsp;
                                                        <BodyTextValue text={profiles.primaryEmail} />
                                                    </div>
                                                    <div
                                                        style={{
                                                            color: '#828282',
                                                            fontSize: '16px',
                                                            fontFamily: 'Roboto',
                                                            paddingTop: '14px',
                                                        }}
                                                    >
                                                        <BodyTextKey text={`${langdata.PhoneNumber ? langdata.PhoneNumber : 'Phone Number' }`}/>&nbsp;:&nbsp;
                                                        <BodyTextValue text={profiles.primaryContact} />
                                                    </div>
                                                    <div
                                                        style={{
                                                            color: '#828282',
                                                            fontSize: '16px',
                                                            fontFamily: 'Roboto',
                                                            paddingTop: '14px',
                                                        }}
                                                    >
                                                        <BodyTextKey text={`${langdata.AlternatePhoneNumber ? langdata.AlternatePhoneNumber : 'Alternate Phone Number' }`}/>&nbsp;:&nbsp;
                                                        <BodyTextValue text={profiles.secondaryContact} />
                                                    </div>
                                                    <div
                                                        style={{
                                                            color: '#828282',
                                                            fontSize: '16px',
                                                            fontFamily: 'Roboto',
                                                            paddingTop: '14px',
                                                        }}
                                                    >
                                                        <BodyTextKey text={`${langdata.Address ? langdata.Address : 'Address' }`}/>&nbsp;:&nbsp;
                                                        <BodyTextValue text={profiles.address} />
                                                    </div>
                                                    <div
                                                        style={{
                                                            color: '#828282',
                                                            fontSize: '16px',
                                                            fontFamily: 'Roboto',
                                                            paddingTop: '14px',
                                                        }}
                                                    >
                                                        <BodyTextKey text={`${langdata.Countryofresidence ? langdata.Countryofresidence : 'Country of residence' }`}/>&nbsp;:&nbsp;
                                                        <BodyTextValue text={profiles.residentCountry} />
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Card>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </div>
        );
    }

    return requesting === true ? (
        <div style={{ paddingLeft: '50%', paddingTop: '150px' }}>
            <Spin size="large" />
        </div>
    ) : (
        <div>{profBody}</div>
    );
};

export default MyProfileFront;
